import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "50.203",
  height: "57.537",
  viewBox: "0 0 50.203 57.537"
}
const _hoisted_2 = { transform: "translate(1.008 1)" }
const _hoisted_3 = ["stroke"]
const _hoisted_4 = { transform: "translate(8.445 40.157)" }
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["stroke"]
const _hoisted_7 = { transform: "translate(30.177 0)" }
const _hoisted_8 = ["stroke"]
const _hoisted_9 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  __name: 'IconPower2',
  props: {
  color: {
    type: String,
    default: '#D4D4D4',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M150.606,190.169c0,3.122-2.2,6.013-4.92,6.013s-4.92-2.891-4.92-6.013a4.933,4.933,0,1,1,9.84,0Z",
        transform: "translate(-132.862 -184.878)",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_3),
      _createElementVNode("g", _hoisted_4, [
        _createElementVNode("path", {
          d: "M146.363,275.263v13.243a2.142,2.142,0,0,1-2.136,2.136h-.107a2.142,2.142,0,0,1-2.136-2.136V275.263",
          transform: "translate(-141.984 -275.263)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_5),
        _createElementVNode("path", {
          d: "M156.218,275.263v13.243a2.142,2.142,0,0,1-2.136,2.136h-.107a2.142,2.142,0,0,1-2.136-2.136V275.263",
          transform: "translate(-147.461 -275.263)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("g", _hoisted_7, [
        _createElementVNode("path", {
          d: "M201.127,190.378c0,3.245-2.29,6.25-5.114,6.25s-5.115-3.006-5.115-6.25a5.128,5.128,0,1,1,10.229,0Z",
          transform: "translate(-190.898 -184.878)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_8)
      ]),
      _createElementVNode("path", {
        d: "M152.205,243.813V222.88l0-.216-3.366,10.642a1.75,1.75,0,0,1-2.195,1.061l-.041-.014a3.957,3.957,0,0,1-1.37-1.556l-3.811-10.642-.03-.009,2.23,18.455a1.111,1.111,0,0,1-1.128,1.272H129.105a1.111,1.111,0,0,1-1.128-1.272l2.231-18.455-.026.009L126.372,232.8a1.751,1.751,0,0,1-2.195,1.061l-.041-.014a1.714,1.714,0,0,1-1.071-2.166l4.744-14.012-1,2.963,1.177-3.431a3.206,3.206,0,0,1,2.829-2.02h9.971a3.206,3.206,0,0,1,2.829,2.02l1.177,3.431-1-2.963,2.959,8.742,1.743-8.233.176-.468a3.206,3.206,0,0,1,2.829-2.02h13.525a3.206,3.206,0,0,1,2.829,2.02l.18.468L171,232.186a1.714,1.714,0,0,1-1.071,2.167l-.041.014a1.75,1.75,0,0,1-2.195-1.061l-3.366-10.642,0,.216v31.6a2.779,2.779,0,0,1-2.771,2.771h-.529a2.779,2.779,0,0,1-2.771-2.771V235.6h.019v18.883a2.779,2.779,0,0,1-2.771,2.771h-.529a2.779,2.779,0,0,1-2.771-2.771V233.768",
        transform: "translate(-122.975 -201.715)",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_9)
    ])
  ]))
}
}

})